import { PackageEntranceTicket, PackageEntranceTicketKind } from '@models/package'
import * as React from 'react'
import { SubscriptionDetails } from '../models'
import { PackageDetailsEntranceCodes } from '@modules/package/details/entrance-codes'
import { getEntranceTicketDownloadUrl } from '../helper'

interface Props {
  subscriptionDetails: SubscriptionDetails
  showZooBorysewTickets?: boolean
  showHpFunTickets?: boolean
  showSuntagoTickets?: boolean
}

export const SubscriptionDetailsEntranceTickets = ({
  subscriptionDetails,
  showZooBorysewTickets = true,
  showHpFunTickets = true,
  showSuntagoTickets = true,
}: Props) => {
  const { zoo_borysew, suntago, hp_fun } = React.useMemo(
    () =>
      subscriptionDetails.entrance_tickets.reduce(
        (acc, ticket) => {
          if (acc[ticket.kind]) {
            return { ...acc, [ticket.kind]: [...acc[ticket.kind], ticket] }
          }
          return { ...acc, [ticket.kind]: [ticket] }
        },
        { zoo_borysew: [], suntago: [], hp_fun: [] },
      ) as Record<PackageEntranceTicketKind, PackageEntranceTicket[]>,
    [subscriptionDetails.entrance_tickets],
  )

  const availableTickets = [
    {
      title: 'Lista biletów do obiektu ZOO Borysew',
      tickets: zoo_borysew,
      isAvailable: showZooBorysewTickets || !!zoo_borysew.length,
      kind: 'zoo_borysew',
    },
    {
      title: 'Lista biletów do obiektu Suntago',
      tickets: suntago,
      isAvailable: showSuntagoTickets || !!suntago.length,
      kind: 'suntago',
    },
    {
      title: 'Lista biletów do obiektu HP - Fun',
      tickets: hp_fun,
      isAvailable: showHpFunTickets || !!hp_fun.length,
      kind: 'hp_fun',
    },
  ].filter(ticket => ticket.isAvailable)

  return (
    <div>
      {availableTickets.map(ticket => (
        <PackageDetailsEntranceCodes
          key={ticket.kind}
          title={ticket.title}
          entranceTickets={ticket.tickets}
          codesActive={subscriptionDetails.status === 'confirmed'}
          downloadUrl={getEntranceTicketDownloadUrl(subscriptionDetails, ticket.tickets[0])}
        />
      ))}
    </div>
  )
}
